import { CatalogApiDatasource } from '../data/datasources/catalog-api.datasource';
import { CatalogRepositoryImpl } from '../data/repositories/catalog.repository.impl';

const api = new CatalogApiDatasource();
const repository = new CatalogRepositoryImpl(api);

export const catalogContainer = { repository };
